import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { AlertsProvider } from './context/AlertsContext';

// Layout
import AppLayout from './components/AppLayout';

// Pages
import LoginPage        from './pages/auth/LoginPage';
import DashboardPage    from './pages/dashboard/DashboardPage';
import AssetsPage       from './pages/assets/AssetsPage';
import AssetDetailPage  from './pages/assets/AssetDetailPage';
import CarbonPage       from './pages/carbon/CarbonPage';
import ESGPage          from './pages/esg/ESGPage';
import PPAPage          from './pages/ppa/PPAPage';
import GridPage         from './pages/grid/GridPage';
import RegulatoryPage   from './pages/regulatory/RegulatoryPage';
import FinancePage      from './pages/finance/FinancePage';
import MaintenancePage  from './pages/maintenance/MaintenancePage';
import SettingsPage     from './pages/settings/SettingsPage';
import UsersPage        from './pages/settings/UsersPage';
import AuditPage        from './pages/settings/AuditPage';

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center bg-gray-50"><div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />

    <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
      <Route index element={<Navigate to="/dashboard" replace />} />
      <Route path="dashboard"    element={<DashboardPage />} />
      <Route path="assets"       element={<AssetsPage />} />
      <Route path="assets/:id"   element={<AssetDetailPage />} />
      <Route path="carbon"       element={<CarbonPage />} />
      <Route path="esg"          element={<ESGPage />} />
      <Route path="ppa"          element={<PPAPage />} />
      <Route path="grid"         element={<GridPage />} />
      <Route path="regulatory"   element={<RegulatoryPage />} />
      <Route path="finance"      element={<FinancePage />} />
      <Route path="maintenance"  element={<MaintenancePage />} />
      <Route path="settings"     element={<ProtectedRoute roles={['super_admin']}><SettingsPage /></ProtectedRoute>} />
      <Route path="users"        element={<ProtectedRoute roles={['super_admin']}><UsersPage /></ProtectedRoute>} />
      <Route path="audit"        element={<ProtectedRoute roles={['super_admin']}><AuditPage /></ProtectedRoute>} />
    </Route>

    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <AlertsProvider>
            <AppRoutes />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: { fontSize: '14px', maxWidth: '420px' },
                success: { iconTheme: { primary: '#1D6B4E', secondary: '#fff' } },
              }}
            />
          </AlertsProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
